import ClaimsByType from './ClaimsByType';

export default ClaimsByType;
